import { render, staticRenderFns } from "./SecureCode.vue?vue&type=template&id=70822c58&scoped=true&"
import script from "./SecureCode.vue?vue&type=script&lang=ts&"
export * from "./SecureCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70822c58",
  null
  
)

export default component.exports